import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { Store } from "@ngrx/store";
import * as _ from "lodash";
import { of } from "rxjs";
import { catchError, map, switchMap, withLatestFrom } from "rxjs/operators";

import { ConsumerService } from "../../../services/api/consumer.service";
import { ConsumerActions } from "../../actions/consumer.actions";
import { FailState } from "../../models/fail-state";
import { AppState } from "../../reducers";
import { ConsumerSelectors } from "../../selectors/consumer.selectors";

@Injectable()
export class DataPerProductStatsGetEffects {
	get = createEffect(() =>
		this.actions.pipe(
			ofType(ConsumerActions.dataPerProductStats.get),
			withLatestFrom(this.store.select(ConsumerSelectors.dataPerProductStats)),
			switchMap(([action, state]) =>
				!_.has(state, "error") && !state.loading
					? of(ConsumerActions.dataPerProductStats.getSuccess(state))
					: of(ConsumerActions.dataPerProductStats.getApi())
			)
		)
	);

	getApi = createEffect(() =>
		this.actions.pipe(
			ofType(ConsumerActions.dataPerProductStats.getApi),
			switchMap(() =>
				this.consumerService.dataPerProductStats().pipe(
					map((stats) =>
						ConsumerActions.dataPerProductStats.getSuccess({ stats, loading: false })
					),
					catchError((error) =>
						of(ConsumerActions.dataPerProductStats.getFail(new FailState(error)))
					)
				)
			)
		)
	);

	constructor(
		private actions: Actions,
		private consumerService: ConsumerService,
		private store: Store<AppState>
	) {}
}
